var buildUrl = function buildUrl(url, parameters){
    if (parameters && parameters.length > 0 && parameters !== null && typeof url == 'string') {
        _.each(parameters, property => {
            let key = '{' + property.key + '}';
            if (typeof url == 'string' && url.indexOf(key) !== -1) {
                url = url.replace(key, property.value)
                if (property.type && property.type != ''){
                    switch (property.type){
                        case 'bool':
                            url = JSON.parse(url);
                            break;
                        case 'int':
                            url = parseInt(url);
                            break;
                    }

                }
            }
        });
    }
    return url;
}

var formatUrl = function formatUrl(item) {
    let url = item.value;
    switch (item.format) {
        case 'phone':
            url = "callto:" + (item.value).replace(/ /g, '')
            break;
        case 'email':
            url = "mailto:" + item.value
            break;
        case 'link':
            url = item.link
            break;
        // case 'url':
        //     switch (item.type){
        //         case 'corporation':
        //             url = `/thirds/${item.relationType}/${item.id}`
        //             break;
        //     }
        //     break;
    }
    return url;
}

var formatActions = function formatActions(actions, item, params) {
    let actionsAvailables = actions
    let dataReturn = []
    if (actionsAvailables.length > 0) {
        actionsAvailables.map(oneAction => {
            if (oneAction.hide !== undefined && oneAction.hide(item) === true) {
                return;
            }

            let action = {}
            action.id = oneAction.id
            action.label = oneAction.label
            action.link = oneAction.link
            action.emitBus = oneAction.emitBus
            action.permission = oneAction.filter !== undefined && oneAction.filter(item) === false ? "false" : this.buildUrl(oneAction.permission, params)
            action.type = oneAction.type
            action.value = this.buildUrl(oneAction.link, params)
            action.childrens = []
            if (oneAction.childrens && oneAction.childrens.length > 0){
                oneAction.childrens.map(child => {
                    let subAction = {}
                    subAction.label = child.label
                    subAction.type = child.type
                    subAction.value = this.buildUrl(child.link, params)
                    subAction.disabled = child.disabled
                    action.childrens.push(subAction)
                })
            }
            dataReturn.push(action)
        })
    }
    return dataReturn
}

var hasAccess = function hasAccess(permission, permissions) {
    if (!permissions) return true;
    if (permission === true)  return true
    if (permission === false) return false

    // Check method
    let checkOne = (permission, permissions) => !!permissions[permission];

    // Checks
    if (!!permission) {
        // Single permission
        if (typeof permission == 'string') {
            if (!checkOne(permission, permissions)) return false;
        }
        // Mutliple permissions
        else if (Array.isArray(permission)) {
            let checksAreOk = true
            permission.forEach(one => {
                if (!checkOne(one, permissions)) checksAreOk = false;
            })
            if (!checksAreOk) return false
        }
    }

    return true
}

var periods = [
    {
        value: 'all',
        label: Loc.g("Depuis le début")
    },
    {
        value: 'lastyear',
        label: Loc.g("L'année dernière")
    },
    {
        value: 'currentyear',
        label: Loc.g("Cette année")
    },
    {
        value: 'last12month',
        label: Loc.g("Des 12 derniers mois")
    },
    {
        value: 'last6month',
        label: Loc.g("Des 6 derniers mois")
    },
    {
        value: 'lastmonth',
        label: Loc.g("Du mois dernier")
    },
    {
        value: 'last30days',
        label: Loc.g("Les 30 derniers jours")
    },
    {
        value: 'currentmonth',
        label: Loc.g("De ce mois")
    },
    {
        value: 'lastweek',
        label: Loc.g("De la semaine dernière")
    },
    {
        value: 'currentweek',
        label: Loc.g("De cette semaine")
    },
    {
        value: 'yesterday',
        label: Loc.g("Hier")
    },
    {
        value: 'today',
        label: Loc.g("Aujourd'hui")
    },
]


var incomingPeriods = [
    {
        value: 'tomorrow',
        label: Loc.g("Demain")
    },
    {
        value: 'nextweek',
        label: Loc.g("La semaine prochaine")
    },
    {
        value: 'nextmonth',
        label: Loc.g("Le mois prochain")
    },
    {
        value: 'next30day',
        label: Loc.g("Les 30 prochains jours")
    },
]



var dateIntervalObject = function (intervalType) {
    let start = moment()
    let end = moment()

    switch (intervalType) {
        case 'all':
            start = ''
            end = ''
            break;
        case 'lastyear':
            start = moment().subtract(1, 'years').startOf('year');
            end = moment().subtract(1, 'years').endOf('year');
            break;
        case 'currentyear':
            start = moment().startOf('year');
            end = moment().endOf('year');
            break;
        case 'last12month':
            start = moment().subtract(12, 'months');
            end = moment()
            break;
        case 'last6month':
            start = moment().subtract(6, 'months');
            end = moment()
            break;
        case 'lastmonth':
            start = moment().subtract(1, 'months').startOf('month');
            end = moment().subtract(1, 'months').endOf('month');
            break;
        case 'currentmonth':
            start = moment().startOf('month');
            end = moment().endOf('month');
            break;
        case 'lastweek':
            start = moment().subtract(7, 'days').startOf('week');
            end = moment().subtract(7, 'days').endOf('week');
            break;
        case 'currentweek':
            start = moment().startOf('week');
            end = moment().endOf('week');
            break;
        case 'yesterday':
            start = moment().subtract(1, 'days').startOf('day');
            end = moment().subtract(1, 'days').endOf('day');
            break;
        case 'last30days':
            start =  moment().subtract(30, 'days').startOf('day');
            end =  moment().startOf('day');
            break;
        case 'tomorrow':
            start = moment().add(1, 'days').startOf('day');
            end = start.clone().endOf('day');
            break;
        case 'today':
            start = moment().startOf('day');
            end = moment().endOf('day');
            break;
        case 'nextweek':
            start =  moment().add(1, 'weeks').startOf('week');
            end = start.clone().endOf('week');
            break;
        case 'nextmonth':
            start =  moment().add(1, 'months').startOf('month');
            end = start.clone().endOf('month');
            break;
        case 'next30day':
            start =  moment().startOf('day');
            end = start.clone().add(30, 'days').endOf('day');
            break;
    }

    return {
        start: start != '' ? start : null,
        end: end != '' ? end : null
    }
};

var dateInterval = function dateInterval(intervalType, today) {
    let interval = dateIntervalObject(intervalType);
    interval.start = interval.start !== null ? interval.start.format('YYYY-MM-DD') : '';
    interval.end = interval.end !== null ? interval.end.format('YYYY-MM-DD') : '';
    return interval;
}

var removeDataFromMap = function removeDataFromMap(dataToRemove, dataMap){
    dataToRemove.map(toRemove => {
        if (dataMap[toRemove.key]) {
            toRemove.values.map(value => {
                let index = dataMap[toRemove.key].findIndex(map => map.id == value)
                dataMap[toRemove.key].splice(index, 1)
            })
        }
    })
}

var deepCopy = function deepCopy(object){
    if (!_.isObject(object)) return;
    return JSON.parse(JSON.stringify((object)));
}
var guid = function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
/**
 * Build route of url from name, with params (optionnal)
 *
 * @param {string} name
 * @param {array[Object]} params (ex: [{key: id, value: 1}])
 * @param {boolean} fullUrl
 */
var getRouteByName = function getRouteByName(name, params, fullUrl) {
    let route = this.$router.options.routes.find(r => r.name == name);
    return this.buildRoute(route, params, fullUrl)
}

var buildRoute = function buildRoute(route, params, fullUrl){
    if (route === undefined) return;

    let path = route.path;
    // add params to path
    if (!!params && !!params.length) path = this.buildUrl(path, params)

    return (!!fullUrl ? window.location.protocol + "//" + window.location.host : '') + path
}

var goToUrl = (url) => {
    if (url && url != '') {
        window.location.href = url
    } else {
        Push.error(this.$l10n.__('Url non correct.'), false)
    }
}

var setDatabotsNavMap = (navMap, databots) => {
    if (navMap.length > 0){
        navMap.map(group => {
            if (group.items.length > 0) {
                group.items.map(item => {
                    item.databot = databots[item.id]
                })
            }
        })
    }
}

export {
    buildUrl,
    formatUrl,
    formatActions,
    hasAccess,
    dateInterval,
    dateIntervalObject,
    periods,
    incomingPeriods,
    removeDataFromMap,
    deepCopy,
    guid,
    getRouteByName,
    goToUrl,
    buildRoute,
    setDatabotsNavMap
}
